import * as colors from '../styles/colors';
import { font } from '../styles/font';
const {
  fontSize,
  fontFamily,
  fontFamilyBold,
  fontFamilyMedium
} = font;
const settings = {
  border: {
    radius: '4px',
    style: 'solid'
  },
  boxShadows: {
    large: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
    small: '0 2px 2px 0 rgba(0, 0, 0, 0.25)'
  },
  colors: {
    bgDisabled: colors.dark12,
    bgProgress: colors.brand12,
    border: colors.dark6,
    borderFocus: colors.info5,
    borderHover: colors.brand,
    borderTab: colors.dark2,
    danger: colors.danger5,
    default: colors.dark,
    disabled: colors.dark4,
    divider: colors.dark4,
    focus: colors.blue4,
    // 'rgba(21, 26, 48, 0.1)',
    hover: colors.blue13,
    info: colors.info5,
    input: colors.dark,
    inputHover: colors.brand,
    label: colors.dark8,
    link: colors.info5,
    linkHover: colors.info6,
    placeholder: colors.dark6,
    pressing: colors.blue6,
    primary: colors.brand,
    scrollbar: colors.brand13,
    scrollbarHover: colors.brand15,
    secondary: colors.dark6,
    success: colors.success5,
    text: colors.dark,
    warning: colors.warning5,
    white: colors.white,
    button: {
      bgFilledHover: {
        danger: colors.danger6,
        info: colors.info6,
        primary: '#0C1550',
        success: colors.success6,
        warning: colors.warning6
      },
      bgHover: {
        danger: colors.danger1,
        info: colors.info1,
        primary: colors.blue13,
        success: colors.success1,
        warning: colors.warning1
      },
      borderHover: {
        danger: colors.danger6,
        info: colors.info6,
        primary: '#0C1550',
        success: colors.success6,
        warning: colors.warning6
      },
      colorHover: {
        danger: colors.danger6,
        info: colors.info6,
        primary: '#0C1550',
        success: colors.success6,
        warning: colors.warning6
      }
    },
    calendar: {
      table: {
        bgDefault: colors.white
      },
      day: {
        default: colors.dark,
        saturday: colors.info8,
        sunday: colors.danger8
      }
    },
    accordion: {
      labelColor: colors.info5,
      background: colors.brand12
    }
  },
  typography: {
    fontFamily,
    fontFamilyMedium,
    fontFamilyBold,
    fontSize,
    title1: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '28px',
      lineHeight: '32px'
    },
    title2: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '26px',
      lineHeight: '30px'
    },
    title3: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '24px',
      lineHeight: '28px'
    },
    title4: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '22px',
      lineHeight: '26px'
    },
    h1: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '20px',
      lineHeight: '24px'
    },
    h2: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '18px',
      lineHeight: '22px'
    },
    h3: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '16px',
      lineHeight: '20px'
    },
    h4: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '18px'
    },
    h5: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '12px',
      lineHeight: '16px'
    },
    h6: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '16px'
    },
    p1: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '20px'
    },
    p2: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '18px'
    },
    p3: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '12px',
      lineHeight: '16px'
    },
    button: {
      textTransform: 'uppercase'
    },
    label: {
      fontSize: 12,
      fontFamily,
      fontWeight: 'bold'
    },
    helperText: {
      fontSize: 12,
      fontFamily,
      fontWeight: 'normal'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    },
    down: value => getMedia(value, 'max'),
    up: value => getMedia(value, 'min'),
    only: value => getMedia(value, 'min', value),
    between: (start, end) => getMedia(start, 'min', end)
  }
};

const getMedia = (value, type, value2 = '') => {
  const values = settings.breakpoints.values;
  let px1,
      px2 = '';

  if (typeof value === 'number') {
    px1 = value + 'px';
  } else if (/^xs|sm|md|lg|xl$/) {
    px1 = values[value] - (type === 'max' ? 0.05 : 0) + 'px';
  }

  if (value2) {
    const keys = Object.keys(values);

    if (value2 === value) {
      // only
      value2 = values[keys[keys.indexOf(value) + 1]] - 0.05 + 'px';
    } else {
      if (typeof value2 === 'number') {
        value2 += 'px';
      } else if (/^xs|sm|md|lg|xl$/) {
        value2 = values[keys[keys.indexOf(value2) + 1]] - 0.05 + 'px';
      }
    }

    px2 = ` and (max-width: ${value2})`;
  }

  return `@media (${type}-width: ${px1}${px2})`;
};

export default settings;